import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PictureList from '../components/PictureList';
import PictureSortDropdown from '../components/PictureSortDropdown';
import PictureListState from '../states/PictureListState';

const translationPrefix = 'kilowhat-cimaise.forum.picture-list.';

export default class PictureListPage extends Page {
    pictureList!: PictureListState

    oninit(vnode: any) {
        super.oninit(vnode);

        this.pictureList = new PictureListState({
            q: '-is:draft',
        });
        this.pictureList.refresh();
    }

    view() {
        return m('.container', [
            m('h2', app.translator.trans(translationPrefix + 'title')),
            m(PictureSortDropdown, {
                sort: this.pictureList.params.sort,
                onchange: (value: string) => {
                    this.pictureList.params.sort = value;
                    this.pictureList.refresh();
                },
            }),
            m(PictureList, {
                state: this.pictureList,
                thumbnailAttrs: {
                    showUser: true,
                    showAlbum: true,
                },
            }),
        ]);
    }
}
